import { cn } from '@/lib/utils';

type JsonBlockProps = { children: string; className?: string };

/** Scrollable code block for a tool's JSON schema preview and its test result. */
const JsonBlock = ({ children, className }: JsonBlockProps) => (
  <pre
    className={cn(
      'overflow-auto rounded-md border border-border bg-background p-3 font-mono text-xs leading-5 text-foreground',
      className
    )}
  >
    {children}
  </pre>
);

export default JsonBlock;
